import React from "react";
import { FaRegHeart } from "react-icons/fa";
import { FaIndianRupeeSign } from "react-icons/fa6";
import img1 from "../../assets/images/ladders/lader17.JPG";
import img2 from "../../assets/images/ladders/lader2.JPG";
import img3 from "../../assets/images/ladders/lader3.JPG";
import img4 from "../../assets/images/ladders/lader4.JPG";
import img5 from "../../assets/images/ladders/lader6.JPG";
import img6 from "../../assets/images/ladders/lader10.JPG";
import img7 from "../../assets/images/ladders/lader11.JPG";
import img8 from "../../assets/images/ladders/lader12.JPG";
import img9 from "../../assets/images/ladders/lader13.JPG";
import img10 from "../../assets/images/ladders/lader23.JPG";
import img11 from "../../assets/images/ladders/lader16.JPG";
import img12 from "../../assets/images/ladders/lader25.JPG";
import img13 from "../../assets/images/ladders/lader8.JPG";
import img14 from "../../assets/images/ladders/lader9.JPG";
import img15 from "../../assets/images/ladders/lader29.JPG";
import img16 from "../../assets/images/ladders/lader20.JPG";
import img17 from "../../assets/images/ladders/lader26.JPG";
import img18 from "../../assets/images/ladders/ladder27.jpeg";
import img19 from "../../assets/images/ladders/lader28.jpeg";

const Products = () => {
  // Array of product data
  const products = [
    { id: 1, image: img1, name: "Self Support Ladder", size: "Feet - 7" },
    { id: 2, image: img2, name: "Self Support Ladder", size: "Feet - 5" },
    { id: 3, image: img3, name: "Wall Support Ladder", size: "Feet - 8" },
    { id: 4, image: img4, name: "Self Support Ladder", size: "Feet - 4" },
    { id: 5, image: img5, name: "Self Support Ladder", size: "Feet - 3" },
    { id: 6, image: img6, name: "Self Support Ladder", size: "Feet - 5" },
    { id: 7, image: img7, name: "Self Support Ladder", size: "Feet - 2" },
    { id: 8, image: img8, name: "Self Support Ladder", size: "Feet - 3" },
    { id: 9, image: img9, name: "Tiltable Ladder", size: "Feet - 17" },
    { id: 10, image: img10, name: "Self Support Ladder", size: "Feet - 1" },
    { id: 11, image: img11, name: "Wall Support Ladder", size: "Feet - 4" },
    { id: 12, image: img12, name: "Self Support Ladder", size: "Feet - 4" },
    { id: 13, image: img13, name: "Self Support Ladder", size: "Green Ladder Collection" },
    { id: 14, image: img14, name: "Self Support Ladder", size: "Feet - 7" },
    { id: 15, image: img15, name: "Self Support Ladder", size: "Feet - 7" },
    
  ];

  const Large = [
    { id: 16, image: img16, name: "Self Support Ladder", size: "Feet - 1" },
    { id: 17, image: img17, name: "Wall Support Ladder", size: "Feet - 14" },
    { id: 18, image: img18, name: "Tiltable Ladder", size: "Extendable Ladder" },
    { id: 19, image: img19, name: "Self Support Ladder", size: "Green Ladder Collection" },
  ]

  return (
    <>
      <div className="text-center p-5 md:p-10" data-aos="fade-up"
     data-aos-anchor-placement="center-center">
        <h1 className="font-bold text-4xl md:mb-4 text-[#142a4e]">Our Products</h1>
      </div>

      {/* Grid Section */}
      <section
        id="Projects"
        className="w-fit mx-auto grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 justify-items-center justify-center gap-y-20 gap-x-14 mt-10 mb-5" data-aos="fade-up" data-aos-duration="3000">
        {products.map((product) => (
          <div
            key={product.id}
            className="w-72 bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl"
          >
            <a href="#">
              <img
                src={product.image}
                alt={product.name}
                className="h-80 w-72 rounded-t-xl"
              />
              <div className="px-4 py-3 w-72">
                <p className="text-lg font-semibold  truncate block capitalize">
                  {product.name}
                </p>
                <div className="flex items-center">
                  <p className="text-lg font-semibold text-[#142a4e] cursor-auto my-3 flex items-center">
                    
                    {product.size}
                  </p>
                  
                  <div className="ml-auto">
                    <FaRegHeart className="text-xl text-gray-500" />
                  </div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </section>

      <section
        id="Projects2"
        className="w-full container mx-auto px-3 md:px-10 lg:px-20 grid grid-cols-1 lg:grid-cols-2 justify-items-center justify-center gap-y-20 gap-x-12 mt-10 mb-5" data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1000"
      >
        {Large.map((product) => (
          <div
            key={product.id}
            className=" w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl"
          >
            <a href="#">
              <img
                src={product.image}
                alt={product.name}
                className="h-80  rounded-t-xl w-full"
              />
              <div className="px-4 py-3">
                <p className="text-lg font-bold text-black truncate block capitalize">
                  {product.name}
                </p>
                <div className="flex items-center">
                  <p className="text-lg font-semibold text-[#142a4e] cursor-auto my-3 flex items-center">
                    
                    {product.size}
                  </p>
                  {/* <del>
                    <p className="text-sm text-gray-600 cursor-auto ml-2 flex items-center">
                      <FaIndianRupeeSign />
                      {product.oldPrice}
                    </p>
                  </del> */}
                  <div className="ml-auto">
                    <FaRegHeart className="text-xl text-gray-500" />
                  </div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </section>
    </>
  );
};

export default Products;
